import React, {useCallback, useEffect, useState} from 'react'
import styles from './CrewReviewPage.module.css'
import LoadingBackdrop from "../../../../components/common/LoadingBackdrop";


import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableFooter from '@mui/material/TableFooter';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import axios from "axios";

const PaystubPage = (params) => {
    const [loadingBackdrop, setLoadingBackdrop] = React.useState(false)
    const [paystubData, setPaystubData] = useState([]);
    const [totals, setTotals] = React.useState({
        mo_dt_to: 0, mo_mdl_to: 0, mo_mhr_to: 0, mo_ot_to: 0, mo_pd_to: 0, mo_st_to: 0,
        tu_dt_to: 0, tu_mdl_to: 0, tu_mhr_to: 0, tu_ot_to: 0, tu_pd_to: 0, tu_st_to: 0,
        we_dt_to: 0, we_mdl_to: 0, we_mhr_to: 0, we_ot_to: 0, we_pd_to: 0, we_st_to: 0,
        th_dt_to: 0, th_mdl_to: 0, th_mhr_to: 0, th_ot_to: 0, th_pd_to: 0, th_st_to: 0,
        fr_dt_to: 0, fr_mdl_to: 0, fr_mhr_to: 0, fr_ot_to: 0, fr_pd_to: 0, fr_st_to: 0,
        sa_dt_to: 0, sa_mdl_to: 0, sa_mhr_to: 0, sa_ot_to: 0, sa_pd_to: 0, sa_st_to: 0,
        su_dt_to: 0, su_mdl_to: 0, su_mhr_to: 0, su_ot_to: 0, su_pd_to: 0, su_st_to: 0,
        to_dt_to: 0, to_mdl_to: 0, to_mhr_to: 0, to_ot_to: 0, to_pd_to: 0, to_st_to: 0,
    })

    const getPaystubData = async () => {
        setLoadingBackdrop(true);
        try {
            const response = await axios.post(`fieldsystemtimereviewcrewpay`, {
                foremanid: params.foremanid,
                weekend: params.weekend
            });

            const parsedResponse = JSON.parse(response?.data?.jsonString);
            setPaystubData(parsedResponse.timeentrylist)
            // return parsedResponse;
        } catch (error) {
            console.error('Failed to get paystub data:', error);
        } finally {
            setLoadingBackdrop(false);
        }
    };

    useEffect(() => {
        getPaystubData();
    }, [params.foremanid, params.weekend]);

    useEffect(() => {

        if (paystubData && paystubData.length > 0) {
            // buildCalculations()
            sumLikeKeys(paystubData)
        }

    }, [paystubData])
    const buildCalculations = () => {
        paystubData.map((item) => {
            const keys = Object.keys(item)
            keys.map(key => {
                setTotals(prevState => {
                    prevState[key + '_to'] = prevState[key+ '_to'] ? prevState[key + '_to'] + item[key] : item[key]
                    return prevState
                })
                debugger
                // item[key + '_to'] = item[key+ '_to'] ? item[key + '_to'] + item[key] : item[key]
            })
        })
        debugger
    }

    const sumLikeKeys = (data) => {
        const result = {
            mo_dt_to: 0, mo_mdl_to: 0, mo_mhr_to: 0, mo_ot_to: 0, mo_pd_to: 0, mo_st_to: 0,
            tu_dt_to: 0, tu_mdl_to: 0, tu_mhr_to: 0, tu_ot_to: 0, tu_pd_to: 0, tu_st_to: 0,
            we_dt_to: 0, we_mdl_to: 0, we_mhr_to: 0, we_ot_to: 0, we_pd_to: 0, we_st_to: 0,
            th_dt_to: 0, th_mdl_to: 0, th_mhr_to: 0, th_ot_to: 0, th_pd_to: 0, th_st_to: 0,
            fr_dt_to: 0, fr_mdl_to: 0, fr_mhr_to: 0, fr_ot_to: 0, fr_pd_to: 0, fr_st_to: 0,
            sa_dt_to: 0, sa_mdl_to: 0, sa_mhr_to: 0, sa_ot_to: 0, sa_pd_to: 0, sa_st_to: 0,
            su_dt_to: 0, su_mdl_to: 0, su_mhr_to: 0, su_ot_to: 0, su_pd_to: 0, su_st_to: 0,
            to_dt_to: 0, to_mdl_to: 0, to_mhr_to: 0, to_ot_to: 0, to_pd_to: 0, to_st_to: 0,
        };

        data.forEach(obj => {
            Object.keys(obj).forEach(key => {
                if (key.startsWith('mo') || key.startsWith('tu') || key.startsWith('we') || key.startsWith('th') || key.startsWith('fr')
                    || key.startsWith('sa') || key.startsWith('su') || key.startsWith('to')) {
                    const newKey = `${key}_to`;
                    result[newKey] = (result[newKey] || 0) + obj[key];
                }
            });
        });

        console.log(result)
        debugger
        return setTotals(result)
    }

    const sumRow = (row, type) => {
        return row['mo_' + type] + row['tu_' + type] + row['we_' + type] + row['th_' + type] + row['fr_' + type] + row['sa_' + type] + row['su_' + type]
    }

    const sumRowFinalTotals = (type) => {
        return totals['mo_' + type + '_to'] + totals['tu_' + type + '_to'] + totals['we_' + type + '_to'] + totals['th_' + type + '_to'] + totals['fr_' + type + '_to'] + totals['sa_' + type + '_to'] + totals['su_' + type + '_to']
    }


    return (
        <div className={styles.root}>
            <LoadingBackdrop open={loadingBackdrop} />
            <div style={{display: loadingBackdrop ? 'none' : 'inline-flex'}}>
                <TableContainer component={Paper}>
                    <Table  aria-label="simple table" stickyHeader={true}>
                        <TableHead aria-label="sticky table">
                            <TableRow>
                                <TableCell sx={{
                                    position: 'sticky',
                                    left: 0,
                                    backgroundColor: 'white',
                                    zIndex: 10001
                                }} align="center">
                                </TableCell>
                                <TableCell align="center" colSpan={6}>
                                    Monday
                                </TableCell>
                                <TableCell align="center" colSpan={6}>
                                    Tuesday
                                </TableCell>
                                <TableCell align="center" colSpan={6}>
                                    Wednesday
                                </TableCell>
                                <TableCell align="center" colSpan={6}>
                                    Thursday
                                </TableCell>
                                <TableCell align="center" colSpan={6}>
                                    Friday
                                </TableCell>
                                <TableCell align="center" colSpan={6}>
                                    Saturday
                                </TableCell>
                                <TableCell align="center" colSpan={6}>
                                    Sunday
                                </TableCell>
                                <TableCell align="center" colSpan={6}>
                                    Weekly Total
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell sx={{
                                    width: '400px',
                                    position: 'sticky',
                                    left: 0,
                                    backgroundColor: 'white',
                                    borderRight: 1,
                                    zIndex: 10001
                                }}>Employee Name</TableCell>
                                {/*Mon*/}
                                <TableCell align="center">ST</TableCell>
                                <TableCell align="center">OT</TableCell>
                                <TableCell align="center">DT</TableCell>
                                <TableCell align="center">Per Diem</TableCell>
                                <TableCell align="center">Meals HR</TableCell>
                                <TableCell align="center">Meals $</TableCell>

                                {/*Tue*/}
                                <TableCell sx={{borderLeft: 1}} align="center">ST</TableCell>
                                <TableCell align="center">OT</TableCell>
                                <TableCell align="center">DT</TableCell>
                                <TableCell align="center">Per Diem</TableCell>
                                <TableCell align="center">Meals HR</TableCell>
                                <TableCell align="center">Meals $</TableCell>

                                {/*Wed*/}
                                <TableCell sx={{borderLeft: 1}} align="center">ST</TableCell>
                                <TableCell align="center">OT</TableCell>
                                <TableCell align="center">DT</TableCell>
                                <TableCell align="center">Per Diem</TableCell>
                                <TableCell align="center">Meals HR</TableCell>
                                <TableCell align="center">Meals $</TableCell>

                                {/*Thurs*/}
                                <TableCell sx={{borderLeft: 1}} align="center">ST</TableCell>
                                <TableCell align="center">OT</TableCell>
                                <TableCell align="center">DT</TableCell>
                                <TableCell align="center">Per Diem</TableCell>
                                <TableCell align="center">Meals HR</TableCell>
                                <TableCell align="center">Meals $</TableCell>

                                {/*Fri*/}
                                <TableCell sx={{borderLeft: 1}} align="center">ST</TableCell>
                                <TableCell align="center">OT</TableCell>
                                <TableCell align="center">DT</TableCell>
                                <TableCell align="center">Per Diem</TableCell>
                                <TableCell align="center">Meals HR</TableCell>
                                <TableCell align="center">Meals $</TableCell>

                                {/*Sat*/}
                                <TableCell sx={{borderLeft: 1}} align="center">ST</TableCell>
                                <TableCell align="center">OT</TableCell>
                                <TableCell align="center">DT</TableCell>
                                <TableCell align="center">Per Diem</TableCell>
                                <TableCell align="center">Meals HR</TableCell>
                                <TableCell align="center">Meals $</TableCell>

                                {/*Sun*/}
                                <TableCell sx={{borderLeft: 1}} align="center">ST</TableCell>
                                <TableCell align="center">OT</TableCell>
                                <TableCell align="center">DT</TableCell>
                                <TableCell align="center">Per Diem</TableCell>
                                <TableCell align="center">Meals HR</TableCell>
                                <TableCell align="center">Meals $</TableCell>

                                {/*Total*/}
                                <TableCell sx={{borderLeft: 1}} align="center">ST</TableCell>
                                <TableCell align="center">OT</TableCell>
                                <TableCell align="center">DT</TableCell>
                                <TableCell align="center">Per Diem</TableCell>
                                <TableCell align="center">Meals HR</TableCell>
                                <TableCell align="center">Meals $</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {paystubData?.map((row) => (
                                <TableRow
                                    key={row.employeename}
                                >
                                    <TableCell sx={{
                                        width: '600px',
                                        position: 'sticky',
                                        left: 0,
                                        backgroundColor: 'white',
                                        zIndex: 10000
                                    }} component="th" scope="row">
                                        <div style={{ width: 150, minWidth: 100, maxWidth: 200 }}>
                                            {row.employeename}
                                        </div>
                                    </TableCell>
                                    <TableCell align="center">{row.mo_st}</TableCell>
                                    <TableCell align="center">{row.mo_ot}</TableCell>
                                    <TableCell align="center">{row.mo_dt}</TableCell>
                                    <TableCell align="center">{row.mo_pd}</TableCell>
                                    <TableCell align="center">{row.mo_mhr}</TableCell>
                                    <TableCell align="center">{row.mo_mdl}</TableCell>

                                    <TableCell align="center">{row.tu_st}</TableCell>
                                    <TableCell align="center">{row.tu_ot}</TableCell>
                                    <TableCell align="center">{row.tu_dt}</TableCell>
                                    <TableCell align="center">{row.tu_pd}</TableCell>
                                    <TableCell align="center">{row.tu_mhr}</TableCell>
                                    <TableCell align="center">{row.tu_mdl}</TableCell>

                                    <TableCell align="center">{row.we_st}</TableCell>
                                    <TableCell align="center">{row.we_ot}</TableCell>
                                    <TableCell align="center">{row.we_dt}</TableCell>
                                    <TableCell align="center">{row.we_pd}</TableCell>
                                    <TableCell align="center">{row.we_mhr}</TableCell>
                                    <TableCell align="center">{row.we_mdl}</TableCell>

                                    <TableCell align="center">{row.th_st}</TableCell>
                                    <TableCell align="center">{row.th_ot}</TableCell>
                                    <TableCell align="center">{row.th_dt}</TableCell>
                                    <TableCell align="center">{row.th_pd}</TableCell>
                                    <TableCell align="center">{row.th_mhr}</TableCell>
                                    <TableCell align="center">{row.th_mdl}</TableCell>

                                    <TableCell align="center">{row.fr_st}</TableCell>
                                    <TableCell align="center">{row.fr_ot}</TableCell>
                                    <TableCell align="center">{row.fr_dt}</TableCell>
                                    <TableCell align="center">{row.fr_pd}</TableCell>
                                    <TableCell align="center">{row.fr_mhr}</TableCell>
                                    <TableCell align="center">{row.fr_mdl}</TableCell>

                                    <TableCell align="center">{row.sa_st}</TableCell>
                                    <TableCell align="center">{row.sa_ot}</TableCell>
                                    <TableCell align="center">{row.sa_dt}</TableCell>
                                    <TableCell align="center">{row.sa_pd}</TableCell>
                                    <TableCell align="center">{row.sa_mhr}</TableCell>
                                    <TableCell align="center">{row.sa_mdl}</TableCell>

                                    <TableCell align="center">{row.su_st}</TableCell>
                                    <TableCell align="center">{row.su_ot}</TableCell>
                                    <TableCell align="center">{row.su_dt}</TableCell>
                                    <TableCell align="center">{row.su_pd}</TableCell>
                                    <TableCell align="center">{row.su_mhr}</TableCell>
                                    <TableCell align="center">{row.su_mdl}</TableCell>

                                    <TableCell align="center">{sumRow(row, 'st')}</TableCell>
                                    <TableCell align="center">{sumRow(row, 'ot')}</TableCell>
                                    <TableCell align="center">{sumRow(row, 'dt')}</TableCell>
                                    <TableCell align="center">{sumRow(row, 'pd')}</TableCell>
                                    <TableCell align="center">{sumRow(row, 'mhr')}</TableCell>
                                    <TableCell align="center">{sumRow(row, 'mdl')}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                        <TableFooter>
                            <TableRow  sx={{}}>
                                <TableCell sx={{
                                    position: 'sticky',
                                    left: 0,
                                    backgroundColor: 'white',
                                    zIndex: 10000
                                }}>Totals</TableCell>
                                {/*Mon*/}
                                <TableCell align="center">{totals.mo_st_to}</TableCell>
                                <TableCell align="center">{totals.mo_ot_to}</TableCell>
                                <TableCell align="center">{totals.mo_dt_to}</TableCell>
                                <TableCell align="center">{totals.mo_pd_to}</TableCell>
                                <TableCell align="center">{totals.mo_mhr_to}</TableCell>
                                <TableCell align="center">{totals.mo_mdl_to}</TableCell>

                                {/*Tue*/}
                                <TableCell align="center">{totals.tu_st_to}</TableCell>
                                <TableCell align="center">{totals.tu_ot_to}</TableCell>
                                <TableCell align="center">{totals.tu_dt_to}</TableCell>
                                <TableCell align="center">{totals.tu_pd_to}</TableCell>
                                <TableCell align="center">{totals.tu_mhr_to}</TableCell>
                                <TableCell align="center">{totals.tu_mdl_to}</TableCell>

                                {/*Wed*/}
                                <TableCell align="center">{totals.we_st_to}</TableCell>
                                <TableCell align="center">{totals.we_ot_to}</TableCell>
                                <TableCell align="center">{totals.we_dt_to}</TableCell>
                                <TableCell align="center">{totals.we_pd_to}</TableCell>
                                <TableCell align="center">{totals.we_mhr_to}</TableCell>
                                <TableCell align="center">{totals.we_mdl_to}</TableCell>

                                {/*Thurs*/}
                                <TableCell align="center">{totals.th_st_to}</TableCell>
                                <TableCell align="center">{totals.th_ot_to}</TableCell>
                                <TableCell align="center">{totals.th_dt_to}</TableCell>
                                <TableCell align="center">{totals.th_pd_to}</TableCell>
                                <TableCell align="center">{totals.th_mhr_to}</TableCell>
                                <TableCell align="center">{totals.th_mdl_to}</TableCell>

                                {/*Fri*/}
                                <TableCell align="center">{totals.fr_st_to}</TableCell>
                                <TableCell align="center">{totals.fr_ot_to}</TableCell>
                                <TableCell align="center">{totals.fr_dt_to}</TableCell>
                                <TableCell align="center">{totals.fr_pd_to}</TableCell>
                                <TableCell align="center">{totals.fr_mhr_to}</TableCell>
                                <TableCell align="center">{totals.fr_mdl_to}</TableCell>

                                {/*Sat*/}
                                <TableCell align="center">{totals.sa_st_to}</TableCell>
                                <TableCell align="center">{totals.sa_ot_to}</TableCell>
                                <TableCell align="center">{totals.sa_dt_to}</TableCell>
                                <TableCell align="center">{totals.sa_pd_to}</TableCell>
                                <TableCell align="center">{totals.sa_mhr_to}</TableCell>
                                <TableCell align="center">{totals.sa_mdl_to}</TableCell>

                                {/*Sun*/}
                                <TableCell align="center">{totals.su_st_to}</TableCell>
                                <TableCell align="center">{totals.su_ot_to}</TableCell>
                                <TableCell align="center">{totals.su_dt_to}</TableCell>
                                <TableCell align="center">{totals.su_pd_to}</TableCell>
                                <TableCell align="center">{totals.su_mhr_to}</TableCell>
                                <TableCell align="center">{totals.su_mdl_to}</TableCell>

                                {/*Weekly Total*/}
                                <TableCell align="center">{sumRowFinalTotals('st')}</TableCell>
                                <TableCell align="center">{sumRowFinalTotals('ot')}</TableCell>
                                <TableCell align="center">{sumRowFinalTotals('dt')}</TableCell>
                                <TableCell align="center">{sumRowFinalTotals('pd')}</TableCell>
                                <TableCell align="center">{sumRowFinalTotals('mhr')}</TableCell>
                                <TableCell align="center">{sumRowFinalTotals('mdl')}</TableCell>
                            </TableRow>
                        </TableFooter>
                    </Table>
                </TableContainer>

                {/*<Container style={{width: '100%'}}>*/}
                {/*</Container>*/}
            </div>
        </div>
    )
}

export default PaystubPage